import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import HowItWorks from './components/HowItWorks';
import FeatureGrid from './components/FeatureGrid';
import ArticleGrid from './components/ArticleGrid';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_PUBLIC_SITE_URL || 'https://vigorbuy.best';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: 'VigorBuy',
      alternateName: 'Vigorbuy Spreadsheet',
      description: 'Vigorbuy Spreadsheet is the ultimate buying resource featuring curated spreadsheets, trusted buying guides, QC resources, and 15+ product categories.',
      publisher: { '@id': `${siteUrl}/#organization` },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'VigorBuy',
      url: `${siteUrl}/`,
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'support@vigorbuy.best',
        contactType: 'customer support',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '315 W 36th Street, Suite 402',
        addressLocality: 'New York',
        addressRegion: 'NY',
        postalCode: '10018',
        addressCountry: 'US',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Vigorbuy Spreadsheet: The Ultimate Buying Resource | VigorBuy',
      description: 'Vigorbuy Spreadsheet is the ultimate buying resource featuring curated spreadsheets, trusted buying guides, QC resources, and 15+ product categories.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      dateModified: '2026-06-28',
    },
    {
      '@type': 'FAQPage',
      '@id': `${siteUrl}/#faq`,
      url: `${siteUrl}/`,
      isPartOf: { '@id': `${siteUrl}/#webpage` },
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is Vigorbuy Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The Vigorbuy Spreadsheet is a carefully curated resource that helps buyers organize products, compare categories, discover popular items, and make smarter purchasing decisions. It includes product lists, pricing comparisons, QC checklists, and direct links to verified sources. Updated daily to ensure accuracy and relevance for every category from sneakers to accessories.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is Vigorbuy safe to use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Absolutely. All links in the Vigorbuy Spreadsheet are verified and sourced from trusted platforms. We provide safety tips, QC guides, and transparent product information so you can shop with complete confidence.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I use the Vigorbuy Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Simply browse through the categories, click on any product link that interests you, and you will be directed to the official store page. The spreadsheet is organized by category for easy navigation. Beginners can start with our getting-started guide.',
          },
        },
        {
          '@type': 'Question',
          name: 'How often are the guides updated?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Our spreadsheets and guides are updated on a daily basis. New products, categories, and resources are added regularly to reflect the latest trends and availability. We maintain a rigorous update schedule to ensure every link, price reference, and guide recommendation remains current and reliable.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is the Vigorbuy Spreadsheet free?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, the Vigorbuy Spreadsheet and all associated guides, QC checklists, buying tips, and category resources are completely free. We believe in making smart shopping accessible to everyone.',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <HowItWorks />
      <FeatureGrid />
      <ArticleGrid />
      <TestimonialSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}